
<form autocomplete="off" [formGroup]="itemVariationsForm" (ngSubmit)="$event.preventDefault()"
        class="form tw-p-5 tw-flex tw-flex-col tw-gap-5">
    <section class="tw-grid tw-grid-cols-12 md:tw-grid-cols-12 tw-gap-x-4 tw-gap-y-3 tw-items-center">
        
        <div class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4 tw-flex tw-items-center">
            <mat-slide-toggle formControlName="is_group_item" aria-label="{{'ITEMS.DETAILS.IS_GROUP_ITEM' | translate}}"
                class="tw-p-2" (change)="onChangeIsGroupItem()"
                >{{'ITEMS.DETAILS.IS_GROUP_ITEM' | translate}}</mat-slide-toggle>
        </div>

        <div class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4 tw-flex tw-items-center">
            <mat-slide-toggle formControlName="split_group_components" aria-label="{{'ITEMS.DETAILS.SPLIT_GROUP_COMPONENTS' | translate}}"
            class="tw-p-2" (change)="onChangeSplitGroupComponents()"
            >{{'ITEMS.DETAILS.SPLIT_GROUP_COMPONENTS' | translate}}</mat-slide-toggle>
        </div>
        
        <div class="tw-col-span-12 md:tw-col-span-6 lg:tw-col-span-4 tw-flex tw-items-center">
            <mat-slide-toggle formControlName="combinationsActive" aria-label="{{'ITEMS.DETAILS.ENABLE_COMBINATIONS' | translate}}"
            class="tw-p-2" (change)="onChangeCombinationsActive()" [disabled]="disableCombinations"
            >{{'ITEMS.DETAILS.ENABLE_COMBINATIONS' | translate}}</mat-slide-toggle>
        </div>

        @if (disableCombinations) {
            <div class="tw-col-span-12 tw-flex tw-items-center">
                <span class="tw-px-3 tw-text-red-500 tw-italic" translate>ITEMS.DETAILS.DISABLE_BOM_COMPONENTS_TO_USE_COMBINATION</span>
            </div>
        }
    </section>

    <app-variations
        [itemId]="item?.id || 0"
        [variationsData]="item?.variations || []"
        [combinationsActive]="itemVariationsSectionService.combinationsActive?.value"
        [splitGroupComponents]="itemVariationsSectionService.split_group_components?.value"
        (requestRemoveVariation)="handleRemoveVariation($event)"
        (requestRemoveVariationValue)="handleRemoveVariationValue($event)"
        (closeAllCombinationsPanel)="handleCloseCombinationsPanel()"
    ></app-variations>
    
    @if(itemVariationsSectionService.combinationsActive?.value && variationsFormService.variationsFormReady()) {
        <app-combinations #combinationsRef
            [itemPriceValue]="priceValue"
            [combinationsData]="combinationsData"
            [variationsData]="variationsFormService.variationsArray || []"
            (requestAddVariation)="handleAddVariation($event)"
            (requestAddVariationValue)="handleAddVariationValue($event)"
            (closeAllVariationsPanel)="handleCloseVariationsPanel()"
        ></app-combinations>
    }
</form>
